import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { createApiClient } from "./lib/api";
import { initAuth } from "./lib/auth";
import { loadConfig } from "./lib/config";
import "./styles.css";

const root = createRoot(document.getElementById("root")!);

async function start() {
  const config = await loadConfig();
  const auth = await initAuth(config.auth);
  if (auth === "redirecting") return;
  const api = createApiClient(config.apiBaseUrl, auth);
  root.render(
    <StrictMode>
      <App api={api} auth={auth} mediaBaseUrl={config.mediaBaseUrl} />
    </StrictMode>,
  );
}

start().catch((error: Error) => {
  root.render(
    <div className="notice error">
      <strong>起動に失敗しました</strong>
      <p>{error.message}</p>
    </div>,
  );
});
